import React, { useState, useContext } from "react";
import "./login.css";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AuthContext from "../../contexts/AuthContext"; 
import { FaEye, FaEyeSlash } from "react-icons/fa"; 

const Login = () => {
  const navigate = useNavigate();
  const { loginUser, loading } = useContext(AuthContext); 

  const [emailAddress, setEmailAddress] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  
  const [validationErrors, setValidationErrors] = useState({
    emailAddress: "",
    password: "",
  });

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const validateFields = () => {
    const errors = {};
    if (!emailAddress.trim()) {
      errors.emailAddress = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(emailAddress)) {
      errors.emailAddress = "Invalid email format.";
    }

    if (!password.trim()) {
      errors.password = "Password is required.";
    } else if (password.length < 6) {
      errors.password = "Password must be at least 6 characters.";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateFields()) {
      toast.error("Please fill in all required fields.", {
        position: "top-right",
        autoClose: 1000,
      });
      return;
    }

    try {
      const response = await loginUser({ emailAddress, password });

      if (response && (response.status === "Failed" || response.code === 404)) {
        toast.error(response.message || "Invalid credentials", {
          position: "top-right",
          autoClose: 2000,
          theme: "colored",
        });
        return; 
      }

      toast.success("Login successful!", {
        position: "top-right",
        autoClose: 1000,
      });
      
      navigate("/");
    } catch (error) {
      toast.error(`Login failed: ${error.message || "Unexpected error"}`, {
        position: "top-right",
        autoClose: 1000,
      });
    }
  };

  return (
    <main id="login" className="py-5">
      <div className="our-container">
        <div className="inner-container">
          <div className="login-block">
            <div className="login-header-block">
              <div className="login-tab-section">
                <Link to={"/log-in"} className="login-link-aTag">Login</Link>
              </div>
            </div>
            <div className="login-body-block">
              <form onSubmit={handleSubmit} autoComplete="off">
                {/* Email Field */}
                <div className="login-email-group mb-4">
                  <label>
                    <span className="text-danger">* </span>Email
                  </label>
                  <div className="login-email-field">
                    <input
                      type="email"
                      className={`form-control ${validationErrors.emailAddress ? "is-invalid" : ""}`}
                      placeholder="Email"
                      value={emailAddress}
                      // ✅ Forces lowercase and disables suggestions
                      onChange={(e) => setEmailAddress(e.target.value.toLowerCase())}
                      autoComplete="one-time-code"
                      autoCorrect="off"
                      spellCheck="false"
                    />
                    {validationErrors.emailAddress && (
                      <div className="invalid-feedback">{validationErrors.emailAddress}</div>
                    )}
                  </div>
                </div>

                {/* Password Field */}
                <div className="login-password-group mb-4">
                  <label>
                    <span className="text-danger">* </span>Password
                  </label>
                  <div className="login-password-field">
                    <input
                      type={showPassword ? "text" : "password"}
                      className={`form-control ${validationErrors.password ? "is-invalid" : ""}`}
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      // ✅ Disables suggestions for password
                      autoComplete="new-password" 
                      autoCorrect="off"
                    />
                    <button 
                      type="button" 
                      className="password-toggle-eye" 
                      onClick={togglePasswordVisibility}
                      tabIndex="-1"
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>

                    {validationErrors.password && (
                      <div className="invalid-feedback">{validationErrors.password}</div>
                    )}
                  </div>
                </div>

                <button type="submit" disabled={loading} className="login-submit-btn">
                  {loading ? "Logging in..." : "Login"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Login;

/* Shutter/Gift Card jsx start */

// import React, { useState, useContext } from "react";
// import "./login.css";
// import { Link, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import AuthContext from "../../contexts/AuthContext"; 
// import { FaEye, FaEyeSlash } from "react-icons/fa"; 

// const Login = () => {
//   const navigate = useNavigate();
//   const { loginUser, loading } = useContext(AuthContext); 

//   const [isOpen, setIsOpen] = useState(false);
//   const [emailAddress, setEmailAddress] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
  
//   const [validationErrors, setValidationErrors] = useState({
//     emailAddress: "",
//     password: "",
//   });

//   const handleInteraction = () => {
//     if (!isOpen) setIsOpen(true);
//   };

//   const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

//   const validateFields = () => {
//     const errors = {};
//     if (!emailAddress.trim()) errors.emailAddress = "Email is required.";
//     if (!password.trim()) errors.password = "Password is required.";
//     setValidationErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateFields()) {
//       // Trigger red toast for validation check
//       toast.error("Please fill in all required fields.", {
//         position: "top-right",
//         theme: "colored"
//       });
//       return;
//     }

//     try {
//       const response = await loginUser({ emailAddress, password });

//       // ✅ FIX: Explicitly checking the body for "Failed" status to show RED toast
//       if (response && (response.status === "Failed" || response.code === 404)) {
//         toast.error(response.message || "Invalid Email or Password", {
//           position: "top-right",
//           autoClose: 3000,
//           theme: "colored", // This makes the toast background solid red
//         });
//         return; 
//       }

//       // If status is not Failed, show Success toast
//       toast.success("Login successful!", {
//         position: "top-right",
//         autoClose: 1000,
//         theme: "colored"
//       });
      
//       navigate("/");
//     } catch (error) {
//       toast.error("An unexpected error occurred. Please try again.", {
//         theme: "colored"
//       });
//     }
//   };

//   return (
//     <div 
//       className={`login-wrapper ${isOpen ? "open" : ""}`}
//       onMouseMove={handleInteraction}
//       onMouseEnter={handleInteraction}
//       onMouseLeave={() => setIsOpen(false)}
//     >
//       <div className="shutter-container">
//         <div className="shutter-part top-red"></div>
//         <div className="shutter-part right-violet"></div>
//         <div className="shutter-part bottom-yellow"></div>
//         <div className="shutter-part left-blue"></div>
//         <div className="center-point-green"></div>
//       </div>

//       <main id="login-form-center-anchor">
//         <div className="login-block">
//           <div className="login-header-block">
//             <div className="login-tab-section">
//               <Link to={"/log-in"} className="login-link-aTag">Login</Link>
//             </div>
//           </div>
//           <div className="login-body-block">
//             <form onSubmit={handleSubmit} autoComplete="off">
//               <div className="login-group">
//                 <label><span className="text-danger">* </span>Email</label>
//                 <div className={`login-input-field ${validationErrors.emailAddress ? "border-danger" : ""}`}>
//                   <input
//                     type="email"
//                     placeholder="Email"
//                     value={emailAddress}
//                     onKeyUp={handleInteraction}
//                     onFocus={handleInteraction}
//                     onChange={(e) => setEmailAddress(e.target.value.toLowerCase())}
//                   />
//                 </div>
//                 {validationErrors.emailAddress && (
//                   <div className="error-message-text">{validationErrors.emailAddress}</div>
//                 )}
//               </div>

//               <div className="login-group mt-3">
//                 <label><span className="text-danger">* </span>Password</label>
//                 <div className={`login-input-field ${validationErrors.password ? "border-danger" : ""}`}>
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     placeholder="Password"
//                     value={password}
//                     onKeyUp={handleInteraction}
//                     onFocus={handleInteraction}
//                     onChange={(e) => setPassword(e.target.value)}
//                   />
//                   <button type="button" className="eye-btn" onClick={togglePasswordVisibility}>
//                     {showPassword ? <FaEyeSlash /> : <FaEye />}
//                   </button>
//                 </div>
//                 {validationErrors.password && (
//                   <div className="error-message-text">{validationErrors.password}</div>
//                 )}
//               </div>

//               <button type="submit" disabled={loading} className="login-submit-btn">
//                 {loading ? "Logging in..." : "Login"}
//               </button>
//             </form>
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default Login;